import { render, staticRenderFns } from "./Authenticated.vue?vue&type=template&id=6f009c64&scoped=true&"
import script from "./Authenticated.vue?vue&type=script&lang=js&"
export * from "./Authenticated.vue?vue&type=script&lang=js&"
import style0 from "./Authenticated.vue?vue&type=style&index=0&id=6f009c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f009c64",
  null
  
)

export default component.exports